import { Instance } from 'mobx-state-tree';
import { SkippedOrderDtoModelBase } from './SkippedOrderDtoModel.base';

/* The TypeScript type of an instance of SkippedOrderDtoModel */
export interface SkippedOrderDtoModelType extends Instance<typeof SkippedOrderDtoModel.Type> {}

/* A graphql query fragment builders for SkippedOrderDtoModel */
export { selectFromSkippedOrderDto, skippedOrderDtoModelPrimitives, SkippedOrderDtoModelSelector } from './SkippedOrderDtoModel.base';

/**
 * SkippedOrderDtoModel
 */
export const SkippedOrderDtoModel = SkippedOrderDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
